import HeroSection from './components/HeroSection';
import MissionApproach from './components/MissionApproach';
import ServiceOverview from './components/ServiceOverview';
import EngineeringValues from './components/EngineeringValues';
import PhilosophyStatement from './components/PhilosophyStatement';
import InnovationManifesto from './components/InnovationManifesto';
import ContactSection from './components/ContactSection';

export default function Home() {
  return (
    <main>
      <HeroSection />
      <MissionApproach />
      <ServiceOverview />
      <EngineeringValues />
      <PhilosophyStatement />
      <InnovationManifesto />
      <ContactSection />
    </main>
  );
}